const Product = () => import(/* webpackChunkName: "product" */ './Product.vue')

const index = {
  path: 'products',
  name: 'Produtos',
  component: Product,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
